import { authService } from './authService'
import { Usuario } from '../types'

interface LoginResponse {
  access_token: string
  token_type: string
  expires_in: number
}

/** @deprecated Preferir authService directamente */
class SimpleAuthService {
  login(username: string, password: string): Promise<LoginResponse> {
    return authService.login(username, password)
  }

  getCurrentUser(token: string): Promise<Usuario> {
    return authService.getCurrentUser(token)
  }

  logout(_token: string): Promise<void> {
    return authService.logout()
  }
}

export const simpleAuthService = new SimpleAuthService()
